// extracted by mini-css-extract-plugin
module.exports = {"buttons":"DonationsFilterDialog_buttons__1OCWy","button":"DonationsFilterDialog_button__2Xyga","leftPart":"DonationsFilterDialog_leftPart__mJsf_"};